import React from 'react';

import { Text } from '@betterment/samba-react';
import { formatDistance } from 'date-fns';

const LinkSent: React.FC<React.PropsWithChildren<{ linkSentAt?: string; queuedAt?: string }>> = ({
  linkSentAt,
  queuedAt,
}) => {
  // @ts-expect-error TS2769 violates strict null checks
  const queuedAtDate = new Date(queuedAt);
  // @ts-expect-error TS2769 violates strict null checks
  const sentAtDate = new Date(linkSentAt);

  if (queuedAt && (queuedAtDate > sentAtDate || !linkSentAt)) {
    return (
      <td>
        <Text>Queued</Text>
      </td>
    );
  }
  if (linkSentAt) {
    return (
      <td>
        <Text>{formatDistance(sentAtDate, new Date(), { addSuffix: true })}</Text>
      </td>
    );
  }
  return (
    <td>
      <Text>--</Text>
    </td>
  );
};

export default LinkSent;
